export const API_BASE_URL="https://demo.softpulseinfotech.com/reactjs-job-portal/"